<template>
  <div v-if="user">
    <div class="field">
      <label class="label">Roles</label>
      <div class="control">
        <div v-if="user.roles && user.roles.length > 0" class="tags">
          <span
            v-for="(role, index) in user.roles"
            :key="index"
            class="tag is-info is-medium"
          >
            {{ role.title }}
          </span>
        </div>
        <p v-else class="help">No roles assigned</p>
      </div>
    </div>

    <div class="field">
      <label class="label">Created At</label>
      <div class="control">
        <input
          class="input"
          type="text"
          :value="formatDate(user.created_at, { showRelative: false })"
          disabled
        />
        <p class="help">{{ formatDate(user.created_at) }}</p>
      </div>
    </div>

    <div class="field">
      <label class="label">Updated At</label>
      <div class="control">
        <input
          class="input"
          type="text"
          :value="formatDate(user.updated_at, { showRelative: false })"
          disabled
        />
        <p class="help">{{ formatDate(user.updated_at) }}</p>
      </div>
    </div>

    <div class="field">
      <label class="label">Timezone</label>
      <div class="control">
        <input
          class="input"
          type="text"
          :value="user.timezone || 'Not set'"
          disabled
        />
      </div>
    </div>

    <div class="field">
      <label class="label">Language</label>
      <div class="control">
        <input
          class="input"
          type="text"
          :value="user.lang || 'Not set'"
          disabled
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDate } from "@/utils/date_converter";

export default {
  name: "UserInfoTab",
  props: {
    userData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["selectedUser"]),
    user() {
      // Prefer userData prop, fallback to selectedUser for backward compatibility
      return this.userData || this.selectedUser;
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style scoped>
.field {
  margin-bottom: 1.5rem;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
